export var DragAndDropActionType = {
  SET_DROP_TARGET: 'SET_DROP_TARGET',
  CLEAR_DROP_TARGET: 'CLEAR_DROP_TARGET',
  TOGGLE_DRAG_MENU: 'TOGGLE_DRAG_MENU'
};

// NOTE: This should be a Union of all possible actions